import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

export default function initTextCarousel() {
  const sliders = document.querySelectorAll('.text-carousel__slider');

  sliders.forEach((slider) => {
    new Splide(slider, {
      type: 'loop',
      drag: false,
      arrows: false,
      pagination: false,
      autoWidth: true,
      gap: 0,
      autoScroll: {
        speed: 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
        easing: 'linear',
      }
    }).mount({AutoScroll});
  });
}
